// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__7WdPp","navList":"Navigation_navList__4liLY","navItem":"Navigation_navItem__u-EYc","link":"Navigation_link__13qe6","navOpen":"Navigation_navOpen__PExdN"};